export default {
    audience_rules: {
        affiliationTypes: [],
        branches: [],
        subgroups: [],
        memberStatus: [
            {
                name: 'Activos',
                _id: "ACTIVE"
            },
            {
                name: 'Inactivos',
                _id: "INACTIVO"
            },
            {
                name: 'Prospectos',
                _id: "PROSPECTO"
            },
            {
                name: 'Expirados',
                _id: "EXPIRED"
            },
        ]
    },
}